import './scss/main.scss';
import { initCorrespondenceSlider } from './js/correspondence.js';
import { initCompanyScroll } from './js/company-scroll.js';
import { initFadeIn } from './js/fade-in.js';
import { initPageLoader } from './js/page-loader.js';
import { initLightbox } from './js/lightbox.js';
import Lenis from 'lenis'
import 'lenis/dist/lenis.css'

const lenis = new Lenis({
  autoRaf: true, // 2026年現在の最新版では、これだけでアニメーションループが自動化されます
  lerp: 0.1,     // 慣性の強さ（0.1が標準。数値が小さいほどヌルヌル動く）
})

// サイドバー（モバイルドロワー）の開閉
const initSidebarToggle = () => {
  const toggle = document.querySelector('.site-sidebar-toggle');
  const sidebar = document.getElementById('site-sidebar');
  if (!toggle || !sidebar) return;

  const setOpen = (open) => {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute(
      'aria-label',
      open ? 'メニューを閉じる' : 'メニューを開く'
    );
    sidebar.classList.toggle('is-open', open);
    document.body.classList.toggle('is-sidebar-open', open);
  };

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    setOpen(!isOpen);
  });

  // ×閉じるボタン
  const closeBtn = sidebar.querySelector('.site-sidebar__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => setOpen(false));
  }

  // オーバーレイタップで閉じる
  document.addEventListener('click', (e) => {
    if (!document.body.classList.contains('is-sidebar-open')) return;
    if (sidebar.contains(e.target) || toggle.contains(e.target)) return;
    setOpen(false);
  });

  // ESCで閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setOpen(false);
  });
};

// エントリーポイント
const boot = () => {
  initPageLoader();
  initSidebarToggle();
  initCorrespondenceSlider();
  initCompanyScroll();
  initFadeIn();
  initLightbox();
  document.documentElement.classList.add('js-ready');
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
